import { SVGProps, Ref, forwardRef } from 'react';

export const BanOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M.5 8C.5 4.25 2.375.5 8 .5s7.5 3.75 7.5 7.5-1.875 7.5-7.5 7.5S.5 11.75.5 8m2.513-3.997C2.256 5.056 1.9 6.464 1.9 8c0 1.667.42 3.184 1.316 4.26.86 1.031 2.308 1.84 4.784 1.84 1.845 0 3.12-.45 4.005-1.105zm9.974 7.994C13.744 10.944 14.1 9.535 14.1 8c0-1.667-.42-3.184-1.316-4.26C11.924 2.709 10.476 1.9 8 1.9c-1.845 0-3.12.45-4.005 1.105z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
BanOutlinedSize16Glyph.displayName = 'BanOutlinedSize16Glyph';
